import * as React from 'react'

export const WORLD_HISTORY = 'worldHistory'
export const AI_KNOWLEDGE = 'aiKnowledge'
export const LITERATURE = 'literature'

const cardData = {
  [WORLD_HISTORY]: {
    title: 'World History Activities',
    content: (
      <div className="content">
        <h3>Who is it for?</h3>
        <p>High school world history and ELA teachers who want to supplement their curriculum with a deep dive into essential world history topics and themes.</p>
        <h3>Pair with OER Project for deeper learning</h3>
        <p>Each activity has a free paired activity from OER Project that can be used in tandem with Quill activities.</p>
      </div>
    ),
    logo: <img alt="Quill logo plus OER Project logo" src={`${window.postbuildEnv.CDN_URL}/images/pages/dashboard/quill-and-oer-logo.svg`} />,
    href: '/assign/social-studies',
    linkAriaLabel: 'See World History Activities'
  },
  [AI_KNOWLEDGE]: {
    title: 'AI Knowledge Activities',
    content: (
      <div className="content">
        <h3>Who is it for?</h3>
        <p>8-12 Computer Science, ELA, or General Education teachers who want to introduce nonfiction articles about AI and its impact on society to their classrooms.</p>
        <h3>Pair with aiEDU for deeper learning</h3>
        <p>Each activity has a free paired activity from our partner nonprofit aiEDU that can be used in tandem with Quill activities.</p>
      </div>
    ),
    logo: <img alt="Quill logo plus aiEDU: The AI Education Project logo" src={`${window.postbuildEnv.CDN_URL}/images/pages/dashboard/quill-and-ai-edu-logo.svg`} />,
    href: '/assign/interdisciplinary-science',
    linkAriaLabel: 'See AI Knowledge Activities'
  },
  [LITERATURE]: {
    title: 'Literature Activities',
    content: (
      <div className="content">
        <h3>Who is it for?</h3>
        <p>Middle and high school ELA teachers who want to supplement their curriculum with engaging nonfiction texts and writing activities related to the author, historical context, or cultural significance of the literary works they&apos;re studying.</p>
        <h3>Pair with Fishtank ELA for deeper learning</h3>
        <p>We offer activities aligned to 7th and 8th grade Fishtank ELA curriculum, with grade 6 coming soon.</p>
      </div>
    ),
    logo: (
      <div className="partner-logos">
        <img alt="Quill logo" src={`${window.postbuildEnv.CDN_URL}/images/logos/quill-logo-green.svg`} />
        <img alt="and" className="and-icon" src={`${window.postbuildEnv.CDN_URL}/images/pages/literature_subject_page/and-icon.svg`} />
        <img alt="Fishtank Learning logo" className="fishtank-logo" src={`${window.postbuildEnv.CDN_URL}/images/pages/literature_subject_page/fishtank-logo.png`} />
      </div>
    ),
    href: '/assign/literature',
    linkAriaLabel: 'See Literature Activities'
  }
}

const ContentHubCard = ({ contentHub, }) => {
  const { title, content, logo, href, linkAriaLabel, } = cardData[contentHub]
  return (
    <section aria-label={title} className="content-hub-card">
      <a aria-label={linkAriaLabel} className="focus-on-light" href={href}>
        <h2>{title}<span className="gold-new-tag">NEW</span></h2>
        {content}
        <div className="logo-container">
          {logo}
        </div>
      </a>
    </section>
  )
}

export default ContentHubCard
